"use strict";

import angular from "angular";

import _ from "lodash";
import template from "./company-contacts-import.component.html";
import "./company-contacts-import.component.scss";

("use strict");

import { CompanyContact } from "../../../entity/CompanyContact";
import { Company } from "../../../gateway/Company/Company";
import { CompanyContactHttpGateway } from "../../../gateway/CompanyContact/CompanyContactHttpGateway";
import { CompanyContactsImportSpreadSheetGenerator } from "../../../presentation/services/CompanyContactsImportSpreadSheetGenerator/CompanyContactsImportSpreadSheetGenerator";
import { CompanyContactsImportSpreadSheetRead } from "../../../presentation/services/CompanyContactsImportSpreadSheetRead/CompanyContactsImportSpreadSheetRead";
import { Events } from "../../../presentation/services/Events/Events";
import { GetCompaniesByFilterUsecase } from "../../../usecases/get-companies-by-filter.usecase";

class CompanyContactsImportComponent {
    Company = new Company();
    CompanyContactHttpGateway = new CompanyContactHttpGateway();
    Events = new Events();
    file = {};
    dropOptions = {
        multiple: false,
        allowDir: false,
        accept: ".xlsx,.xls",
        maxFiles: 1,
        maxSize: "5MB"
    };
    tabStepIndex = 0;
    loading = false;
    contacts = [];
    formContactsImport = {};
    hasError = false;
    loadingFile = false;
    companiesCount = 0;
    constructor($scope, LoaderService, DesnuDialogService) {
        this.$scope = $scope;
        this.LoaderService = LoaderService;
        this.DesnuDialogService = DesnuDialogService;
    }

    $onInit() {}

    async onDropFile(files) {
        if (!files?.length) return;
        this.loadingFile = true;
        this.file = files[0];
        const CompanycontactsImportSpreadSheetRead = new CompanyContactsImportSpreadSheetRead();
        const contacts = await CompanycontactsImportSpreadSheetRead.execute({
            file: this.file
        });
        if (!contacts?.length) {
            this.hasError = true;
        } else {
            this.hasError = false;
        }
        this.loadingFile = false;
        this.$scope.$applyAsync();
    }

    onCancel() {
        this.afterCancel();
        this.hasError = false;
        this.sidenavInstance.close();
    }

    async onSendFile() {
        this.tabStepIndex = 1;
        const CompanycontactsImportSpreadSheetRead = new CompanyContactsImportSpreadSheetRead();
        const contacts = await CompanycontactsImportSpreadSheetRead.execute({
            file: this.file
        });

        this.contacts = contacts.map((c) => {
            const contact = {
                name: c.name,
                whatsapp: c.whatsapp,
                email: c.email,
                companyId: c.company._id,
                accountingId: this.accountingData._id,
                type: "company",
                relations: {
                    nps: {
                        status: c.nps
                    },
                    user: {
                        status: c.user
                    }
                },
                viewModel: {
                    companyName: c.company.name
                }
            };
            if (c._id) contact._id = c._id;
            return CompanyContact.restore(contact);
        });
        this.setCompaniesCount();
        this.afterSendFile();
        this.hasError = false;
        setTimeout(() => {
            for (const control of this.formContactsImport.$$controls) {
                control.$setTouched();
            }
            this.$scope.$applyAsync();
        }, 1000);
    }

    async setCompaniesCount() {
        const getCompaniesByFilterUsecase = new GetCompaniesByFilterUsecase();
        const companies = await getCompaniesByFilterUsecase.execute({
            accountingId: this.accountingData._id,
            filter: {
                status: ["ATIVO", "INATIVO"],
                companyModel: true
            }
        });
        this.companiesCount = companies?.length || 0;
        this.$scope.$applyAsync();
    }

    onReturnStep() {
        this.tabStepIndex = 0;
    }

    async onSave() {
        this.LoaderService.setProgress(true);
        this.loading = true;
        const contactsList = angular.copy(this.contacts);
        const contacts = contactsList.map((contact) => {
            contact.transformRelations();
            contact.setWhatsapp();
            const props = contact.getProps();
            delete props.viewModel;
            return props;
        });
        await this.CompanyContactHttpGateway.saveMany({
            accountingId: this.accountingData._id,
            type: "company",
            contacts
        });
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.Events.setParamns({
            accountingId: this.accountingData._id,
            contatosSalvos: contacts?.length || 0
        });
        this.Events.send("contatos.empresasnucont.enviar.importacao");
        this.$scope.$applyAsync();
        this.openPopupUserNucont(contacts);
        this.afterSave();
    }

    openPopupUserNucont(contacts) {
        const contactsUserNucont = contacts.filter(
            (contact) => contact.relations.user.status
        );
        if (!contactsUserNucont?.length) return;
        this.DesnuDialogService.confirmation({
            locals: {
                width: "546px",
                title: `Você ativou o Login Nucont de ${contactsUserNucont.length} empresas`,
                description: `Foi enviado o link de ativação do login aos contatos cadastrados.
                <br>
                <br>
                Se precisar, acesse a opção (  <i class="fas fa-ellipsis-v"></i>  ) do contato e envie novamente link de ativação.`,
                actions: {
                    confirm: {
                        label: "Entendi",
                        action: async () => {
                            this.DesnuDialogService.hide();
                        }
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }

    async onDownloadSpreadSheet() {
        this.LoaderService.setProgress(true);
        this.loading = true;
        const companycontactsImportSpreadSheetGenerator = new CompanyContactsImportSpreadSheetGenerator();
        await companycontactsImportSpreadSheetGenerator.execute({
            accountingId: this.accountingData._id
        });
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.$scope.$applyAsync();
    }

    onRemoveContact(index) {
        this.contacts.splice(index, 1);
    }

    onRemoveFile() {
        this.file = {};
        this.hasError = false;
    }

    getLabelCompaniesWithContacts() {
        const contacts = _.uniqBy(this.contacts, "props.companyId");
        const companiesWithContacts = Object.keys(contacts);
        return `Há ${companiesWithContacts?.length || 0} de ${
            this.companiesCount || 0
        } empresas com contato`;
    }

    onTryAgain() {
        const element = document.getElementsByClassName(
            "contacts-import-drop-area"
        );
        element.item(0).click();
    }
}

export { CompanyContactsImportComponent };

CompanyContactsImportComponent.$inject = [
    "$scope",
    "LoaderService",
    "DesnuDialogService"
];

const name = "companyContactsImportComponent";
const def = {
    bindings: {
        afterCancel: "&",
        afterSendFile: "&",
        afterSave: "&",
        accountingData: "<",
        sidenavInstance: "<"
    },
    controller: CompanyContactsImportComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
